// extracted by mini-css-extract-plugin
export var chevron = "_jk-3";
export var chevronRotated = "_jk-4";
export var image = "_jk-1";
export var imageContainer = "_jk-0";
export var shippingAddress = "_jk-2";